import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const internalChatApi = createApi({
  reducerPath: "internalChatApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}users/internal-chat/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["InternalChatParticipants", "InternalChatMessages"],
  endpoints: (builder) => ({
    getChatParticipants: builder.query({
      query: () => "participants",
      providesTags: ["InternalChatParticipants"],
    }),
    getChatMessages: builder.query({
      query: ({ participantType, participantId, limit = 50 }) => {
        const params = new URLSearchParams({
          participantType,
          participantId,
          limit: String(limit),
        });
        return `messages?${params.toString()}`;
      },
      providesTags: ["InternalChatMessages"],
    }),
    sendChatMessage: builder.mutation({
      query: ({ receiver_type, receiver_id, message }) => ({
        url: "messages",
        method: "POST",
        body: { receiver_type, receiver_id, message },
      }),
      invalidatesTags: ["InternalChatMessages", "InternalChatParticipants"],
    }),
  }),
});

export const {
  useGetChatParticipantsQuery,
  useGetChatMessagesQuery,
  useSendChatMessageMutation,
} = internalChatApi;
